import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ScrollService {
  /**
   * Gets the current scroll position of the page content container
   */
  getScrollPosition(): { scrollX: number; scrollY: number } {
    const scrollElement = document.querySelector(
      ".contentWrapper",
    ) as HTMLElement;

    if (!scrollElement) {
      return { scrollX: 0, scrollY: 0 };
    }

    return {
      scrollX: scrollElement.scrollLeft,
      scrollY: scrollElement.scrollTop,
    };
  }

  /**
   * Restores the scroll position to a specific value with smooth transition
   */
  restoreScrollPosition(position: { scrollX: number; scrollY: number }): void {
    const scrollElement = document.querySelector(
      ".page-content",
    ) as HTMLElement;

    if (!scrollElement) {
      return;
    }

    if (position.scrollX === 0 && position.scrollY === 0) {
      scrollElement.scrollLeft = 0;
      scrollElement.scrollTop = 0;
      return;
    }

    // Enable smooth scroll temporarily
    const originalBehavior = scrollElement.style.scrollBehavior;
    scrollElement.style.scrollBehavior = "smooth";

    // Restore the position
    scrollElement.scrollLeft = position.scrollX;
    scrollElement.scrollTop = position.scrollY;

    // Restore the original behavior after the animation
    setTimeout(() => {
      scrollElement.style.scrollBehavior = originalBehavior;
    }, 1000);
  }
}
